// molecules/HeaderCartButton.jsx
import React, { useState } from 'react';
import styled from '@emotion/styled';
import CartIcon from 'components/ui/CartIcon';
import Cart from 'components/cart/Cart';

const HeaderCartButtonContainer = styled.div`
  position: relative;
`;

const HeaderCartButton = ({ isScrolled }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const handleCartToggle = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <HeaderCartButtonContainer>
      <CartIcon onClick={handleCartToggle} isScrolled={isScrolled} />
      <Cart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
    </HeaderCartButtonContainer>
  );
};

export default HeaderCartButton;
